<template>
  <div class="table-responsive">
    <table class="table table-borderless table-sm w-100 table-lista">
      <thead>
        <tr>
          <th scope="col" class="text-left">Atendimento</th>
          <th scope="col" class="text-left">Serviço</th>
          <th scope="col" class="text-center">Quantidade</th>
          <th scope="col" class="text-center">Valor Unitário</th>
          <th scope="col" class="text-right">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="text-left">{{ item.dtatendimento }}</td>
          <td class="text-left">{{ item.descrservico || item.servico }}</td>
          <td class="text-center">{{ item.quantidade }}</td>
          <td class="text-center">{{ item.vlrunitario | currency }}</td>
          <td class="text-right">{{ item.vlrtotal | currency }}</td>
        </tr>
        <tr class="linha-total" v-if="items.length > 0">
          <td colspan="2" class="text-left pr-4"><strong>TOTAL:</strong></td>
          <td class="text-center"><strong>{{ totalQtd }}</strong></td>
          <td class="text-center"><strong>-</strong></td>
          <td class="text-right"><strong>{{ totalValor | currency }}</strong></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["items"],
  computed: {
    totalQtd() {
      return this.items.reduce((acc, cur) => acc + (cur.quantidade || 0), 0);
    },
    totalValor() {
      return this.items.reduce((acc, cur) => acc + (cur.vlrtotal || 0), 0);
    }
  },
  filters: {
    currency(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    }
  }
};
</script>

<style scoped>
.linha-total td {
  border-top: 2px solid #dee2e6 !important;
  background-color: #f8f9fa;
  padding: 10px 5px;
}
</style>